import _ from 'underscore';
var locale = 'en_US'; //TODO: Reading value from request
export const custToolHelper = {
  data() {
    return {};
  },
  methods: {
    handle_function_call(methodName, args) {
      var self = this;
      self[methodName](args);
    },
    getItemDefaultValue(acc_ref_id, ref_key, innerAcc_ref_id) {
      var loadedCss = this.$store.state.cssStore.loadedCss;
      var selectedForm = {};
      var innerAccForm = {};
      var form = {
        defaultValue: ''
      };
      selectedForm = _.findWhere(loadedCss, {
        ref_id: acc_ref_id
      });
      if (selectedForm) {
        if (innerAcc_ref_id && selectedForm.innerAccordion) {
          innerAccForm = _.findWhere(selectedForm.innerAccordion, {
            ref_id: innerAcc_ref_id
          });
          if (innerAccForm && innerAccForm.form) {
            form = _.findWhere(innerAccForm.form, {
              ref_key: ref_key
            });
          }
        } else {
          if (selectedForm.form) {
            form = _.findWhere(selectedForm.form, {
              ref_key: ref_key
            });
          }
        }
      }
      return form.defaultValue;
    },
    showHighlight(refClass) {
      console.log('REF Class', refClass)
      if (refClass) {
        this.$store.state.custAppStore.tipsVisible = false
        if (refClass == 'h_tips') {
          this.$store.state.custAppStore.tipsVisible = true
        }
        $('.' + refClass).addClass('highlight-parent')
        $('.' + refClass).prepend($('<div class="highlighter"></div>'))
        let self = this
        setTimeout(function () {
          if ($('.' + refClass + ' .highlighter').length > 0) {
            $('.' + refClass + ' .highlighter').remove()
            $('.' + refClass).removeClass('highlight-parent')
          }
        }, 1500)
      }
    },
    switchPreviewPage(previewPageName) {
      console.log('Page Name', previewPageName)
      if (previewPageName) {
        this.$root.$emit(
          'changePreviewPage',
          previewPageName ? previewPageName : 'fl-finapp'
        )
      }
    },
    clearSearch() {
      this.$store.state.paramStore.showSearchField = false
      this.$store.state.cssStore.showSearchField = false
      this.$store.state.localeStore.showSearchField = false
    },
    querySearch(queryString, cb) {
      if (queryString === "") {
        this.$store.state.paramStore.showSearchField = false
        this.$store.state.cssStore.showSearchField = false
        this.$store.state.localeStore.showSearchField = false
        return
      } else {
        var suggestedText = this.getSuggestedText();
        var results = queryString ?
          suggestedText.filter(this.createFilter(queryString)) :
          suggestedText;
        var split_objects = results.map(function (str) {
          var strArray = str.split();
          return {
            value: strArray[0]
          };
        });
        cb(split_objects);
      }
    },
    createFilter(queryString) {
      return suggestedText => {
        return (
          suggestedText ? suggestedText.toLowerCase().indexOf(queryString.toLowerCase()) === 0 : ''
        );
      };
    },
    getSuggestedText() {
      // Below code to create a json for auto complete search box
      var tempSuggestedText = [];
      var data = this.getSearchData();
      data.forEach(section => {
        if (section && section.form) {
          section.form.forEach(form => {
            tempSuggestedText.push(form.displayName);
            if (form && form.dependentForm) {
              form.dependentForm.forEach(dform => {
                tempSuggestedText.push(dform.displayName);
              });
            }
          });
        }
        // Below code is for CSS search
        if (section && section.innerAccordion) {
          section.innerAccordion.forEach(innerSection => {
            if (innerSection && innerSection.form) {
              innerSection.form.forEach(iform => {
                tempSuggestedText.push(iform.displayName);
              });
            }
          });
        }
      });
      this.$store.state[this.compStoreName].suggestedText = tempSuggestedText;
      return this.$store.state[this.compStoreName].suggestedText;
    },

    // mongo db - param
    generateCobrandJsonParam(src, dist, result) {
      if (_.isArray(src)) {
        var sourceArrayLength = src.length
        for (var i = 0; i < sourceArrayLength; i++) {
          this.generateCobrandJsonParam(src[i], dist[i], result)
        }
      } else if (_.isObject(src)) {
        for (var key in src) {
          if (key == 'dependentForm') {
            this.generateCobrandJsonParam(src[key], dist[key], result)
          } else if (key == 'innerAccordion') {
            this.generateCobrandJsonParam(src[key], dist[key], result)
          } else if (key == 'defaultValue') {
            this._updateCobrandParamJsonKeyValue(
              src['key'],
              src['finappId'],
              src['dataType'],
              src['dotNotationLevel'],
              src['defaultValue'],
              dist['defaultValue'],
              result
            )
          } else if (key == 'form') {
            var formLength = src[key].length
            if (_.isUndefined(src['defaultValue']) && !_.isEmpty(src['key'])) {
              var srcValue = {},
                distValue = {}
              for (var j = 0; j < formLength; j++) {
                var srcForm = src['form'][j]
                var distForm = dist['form'][j]
                srcValue[srcForm['key']] = this._formatValue(
                  srcForm['defaultValue'],
                  srcForm['dataType']
                )
                distValue[distForm['key']] = this._formatValue(
                  distForm['defaultValue'],
                  distForm['dataType']
                )
              }
              this._updateCobrandParamJsonKeyValue(
                src['key'],
                src['finappId'],
                'Object',
                src['dotNotationLevel'],
                srcValue,
                distValue,
                result
              )
            } else {
              for (var k = 0; k < formLength; k++) {
                this.generateCobrandJsonParam(src[key], dist[key], result)
              }
            }
          }
        }
      } else {
        console.error('it is not object and array', src)
      }
    },

    // mongo db - param
    _updateCobrandParamJsonKeyValue(
      key,
      finappId,
      dataType,
      dotNotationLevel,
      srcValue,
      distValue,
      result
    ) {
      var srcStringifyValue, distStringValue
      if (_.isObject(srcValue)) {
        srcStringifyValue = JSON.stringify(srcValue)
        distStringValue = JSON.stringify(distValue)
      } else {
        srcStringifyValue = srcValue.toString()
        distStringValue = distValue.toString()
      }
      if (srcStringifyValue !== distStringValue) {
        result.dataChanged = true
      }
      let subKey;
      if (dotNotationLevel && dotNotationLevel == 1) {
        let keys = key.split('.');
        key = keys[0];
        subKey = keys[1];
      } else {
        if (srcStringifyValue == distStringValue) {
          if( !result.noChangeDataRequired || _.isEmpty(distStringValue) ) {
            return;
          }
        }
      }

      var formattedVal = this._formatValue(distValue, dataType)

      if (_.isEmpty(finappId)) {
        finappId = 'global'
      }
      var dbKey = 'param.default.' + key + '.' + finappId.toLowerCase();
      if (subKey) {
        if (!result.brandJson[dbKey]) {
          result.brandJson[dbKey] = {};
        } else {
          if (_.isUndefined(formattedVal)) {
            formattedVal = distValue;
          }
          result.brandJson[dbKey][subKey] = formattedVal;
        }
      } else {
        result.brandJson[dbKey] = formattedVal
      }
    },

    // mongo db - param
    _formatValue(value, type) {
      var val
      if (type.toLowerCase() == 'number') {
        val = Number(value)
      } else {
        val = value
      }
      return val
    },

    // vue - param
    generateVueJsonParam(src, cobJson) {
      if (_.isArray(src)) {
        var sourceArrayLength = src.length
        for (var i = 0; i < sourceArrayLength; i++) {
          this.generateVueJsonParam(src[i], cobJson)
        }
      } else if (_.isObject(src)) {
        for (var key in src) {
          if (key == 'dependentForm') {
            this.generateVueJsonParam(src[key], cobJson)
          } else if (key == 'innerAccordion') {
            this.generateVueJsonParam(src[key], cobJson)
          } else if (key == 'defaultValue') {
            src['defaultValue'] = this._getCobrandParamValue(
              cobJson,
              src['key'],
              src['finappId'],
              src['dotNotationLevel'],
              src['defaultValue']
            )
          } else if (key == 'form') {
            var formLength = src[key].length
            if (_.isUndefined(src['defaultValue']) && !_.isEmpty(src['key'])) {
              var cobrandValue = this._getCobrandParamValue(
                cobJson,
                src['key'],
                src['finappId'],
                src['dotNotationLevel']
              )
              if (!_.isEmpty(cobrandValue)) {
                for (var j = 0; j < formLength; j++) {
                  var srcForm = src['form'][j]
                  srcForm['defaultValue'] = cobrandValue[srcForm['key']]
                }
              }
            } else {
              for (var k = 0; k < formLength; k++) {
                this.generateVueJsonParam(src[key], cobJson)
              }
            }
          }
        }
      }
    },

    //vue - param
    _getCobrandParamValue(cobJson, key, finappId, dotNotationLevel, defaultValue) {
      var val = defaultValue

      if (_.isEmpty(finappId)) {
        finappId = 'global'
      }

      var cObj = cobJson['default']
      if (!_.isEmpty(cObj)) {

        let subKey;
        if (dotNotationLevel && dotNotationLevel == 1) {
          let keys = key.split('.');
          key = keys[0];
          subKey = keys[1];
        }

        cObj = cObj[key];
        if (!_.isEmpty(cObj)) {
          var cVal = cObj[finappId.toLowerCase()];
          if (!_.isUndefined(cVal)) {
            if (subKey) {
              val = cVal[subKey];
            } else {
              val = cVal
            }
          } else {
            if(!subKey) {
              val = cObj['global'];
            }
          }
        }
      }
      return val
    },

    // mongodb - locale
    generateCobrandJsonLocale(src, dist, result) {
      if (_.isArray(src)) {
        var sourceArrayLength = src.length
        for (var i = 0; i < sourceArrayLength; i++) {
          this.generateCobrandJsonLocale(src[i], dist[i], result)
        }
      } else if (_.isObject(src)) {
        for (var key in src) {
          if (key == 'content') {
            this.generateCobrandJsonLocale(src[key], dist[key], result)
          } else if (key == 'defaultValue') {
            this._updateCobrandLocaleJsonKeyValue(
              src['key'],
              src['defaultValue'],
              dist['defaultValue'],
              result,
              src['other_keys']
            )
          } else if (key == 'form') {
            var formLength = src[key].length
            for (var k = 0; k < formLength; k++) {
              this.generateCobrandJsonLocale(src[key], dist[key], result)
            }
          } else if (key == 'innerAccordion') {
            this.generateCobrandJsonLocale(src[key], dist[key], result)
          }
        }
      } else {
        console.error('it is not object and array', src)
      }
    },

    // mongodb - locale
    _updateCobrandLocaleJsonKeyValue(key, srcValue, distValue, result, otherKeys) {
      if (srcValue !== distValue) {
        result.dataChanged = true
      } else if (!result.noChangeDataRequired || _.isEmpty(distValue)) {
        return
      }
      var dbKey = "locale.default." + key + "." + (locale || 'en_US');
      result.brandJson[dbKey] = distValue

      if (otherKeys) {
        var otherKeysLength = otherKeys.length
        for (var i = 0; i < otherKeysLength; i++) {
          var dbKey = "locale.default." + otherKeys[i] + "." + (locale || 'en_US');
          result.brandJson[dbKey] = distValue;
        }
      }
    },

    // vue - locale
    generateVueJsonLocale(src, cobJson) {
      if (_.isArray(src)) {
        var sourceArrayLength = src.length
        for (var i = 0; i < sourceArrayLength; i++) {
          this.generateVueJsonLocale(src[i], cobJson)
        }
      } else if (_.isObject(src)) {
        for (var key in src) {
          if (key == 'content') {
            this.generateVueJsonLocale(src[key], cobJson)
          } else if (key == 'defaultValue') {
            src['defaultValue'] = this._getCobrandLocaleValue(
              cobJson,
              src['key'],
              src['defaultValue']
            )
          } else if (key == 'form') {
            var formLength = src[key].length
            for (var k = 0; k < formLength; k++) {
              this.generateVueJsonLocale(src[key], cobJson)
            }
          } else if (key == 'innerAccordion') {
            this.generateVueJsonLocale(src[key], cobJson)
          }
        }
      }
    },

    // vue - priate -vlocale
    _getCobrandLocaleValue(cobJson, key, defaultValue) {
      var val = defaultValue

      var cObj = cobJson['default']
      if (!_.isEmpty(cObj)) {
        cObj = cObj[key];
        if (!_.isEmpty(cObj)) {
          var cVal = cObj[locale || 'en_US']
          if (!_.isUndefined(cVal)) {
            val = cVal
          }
        }
      }
      return val
    },

    // vue - css
    generateVueJsonCss(src, cssJson) {
      if (_.isArray(src)) {
        var sourceArrayLength = src.length
        for (var i = 0; i < sourceArrayLength; i++) {
          this.generateVueJsonCss(src[i], cssJson)
        }
      } else if (_.isObject(src)) {
        for (var key in src) {
          if (key == 'content') {
            this.generateVueJsonCss(src[key], cssJson)
          } else if (key == 'defaultValue') {
            src['defaultValue'] = this._getCobrandCssValue(
              cssJson,
              src['key'],
              src['defaultValue']
            )
          } else if (key == 'form') {
            var formLength = src[key].length
            for (var k = 0; k < formLength; k++) {
              this.generateVueJsonCss(src[key], cssJson)
            }
          } else if (key == 'innerAccordion') {
            this.generateVueJsonCss(src[key], cssJson)
          }
        }
      }
    },

    // vue - css 
    _getCobrandCssValue(cssJson, key, defaultValue) {
      var val = defaultValue

      var cObj = cssJson['default']
      if (!_.isEmpty(cObj)) {
        var cVal = cObj[key];
        if (!_.isUndefined(cVal)) {
          val = cVal
        }
      }
      return val
    },

    // mongodb - css 
    generateCobrandJsonCss(src, dist, result) {
      if (_.isArray(src)) {
        var sourceArrayLength = src.length
        for (var i = 0; i < sourceArrayLength; i++) {
          this.generateCobrandJsonCss(src[i], dist[i], result)
        }
      } else if (_.isObject(src)) {
        for (var key in src) {
          if (key == 'content') {
            this.generateCobrandJsonCss(src[key], dist[key], result)
          } else if (key == 'defaultValue') {
            this._updateCobrandCssJsonKeyValue(
              src['key'],
              src['defaultValue'],
              dist['defaultValue'],
              result,
              src['other_keys']
            )
          } else if (key == 'form') {
            var formLength = src[key].length
            for (var k = 0; k < formLength; k++) {
              this.generateCobrandJsonCss(src[key], dist[key], result)
            }
          } else if (key == 'innerAccordion') {
            this.generateCobrandJsonCss(src[key], dist[key], result)
          }
        }
      } else {
        console.error('it is not object and array', src)
      }
    },

    // mongodb - css
    _updateCobrandCssJsonKeyValue(key, srcValue, distValue, result, otherKeys) {
      if (srcValue !== distValue) {
        result.dataChanged = true
      } else if (!result.noChangeDataRequired || _.isEmpty(distValue)) {
        return;
      }

      var dbKey = "cbdk.default." + key;
      result.brandJson[dbKey] = distValue;

      if (otherKeys) {
        var otherKeysLength = otherKeys.length
        for (var i = 0; i < otherKeysLength; i++) {
          var dbKey = "cbdk.default." + otherKeys[i];
          result.brandJson[dbKey] = distValue;
        }
      }
    },

    updateDataSavedStatus() {
      this.$store.state.custAppStore.dataChanged = true;
    }
  }
}